module.exports = __webpack_public_path__ + "img/accounts.daily.a7e28924.png";